module.exports = __webpack_public_path__ + "287dcd12ba1667cf7ba66443ec4cce95.png";